export const breakpoints = {
  base: '0px',
  xs: '380px',
  sm: '480px',
  md: '768px',
  lg: '992px',
  xl: '1280px',
  '2xl': '1536px',
}
